module.exports = __webpack_public_path__ + "img/hlava2.8ea05f23.svg";